import { Button, IconButton } from '@material-ui/core';
import React from 'react';
import './CustomIntegrationsCard.scss';
import InfoIcon from '@mui/icons-material/Info';
import { useHistory } from 'react-router-dom';

const CustomIntegrationsCard = ({ icon, name, subtext }) => {
  const history = useHistory();
  const onRedirect = () => {
    history.push('/integration-details');
  };

  return (
    <div className='integrations-card'>
      <div className='card px-3'>
        <div className='d-flex justify-content-between mt-3'>
          <img width='65' height='65' src={icon} alt={name} />
          <div>
            <IconButton>
              <InfoIcon color='red' />
            </IconButton>
          </div>
        </div>
        <div className='my-3'>
          <h5>{name}</h5>
          <p>{subtext}</p>
        </div>
        <div className='d-flex justify-content-between mt-2 mb-3 '>
          <p className='text-decoration-underline mb-0 pt-1 pointer' onClick={() => onRedirect()}>
            More Details
          </p>
          <Button variant='contained' className='connect-btn'>
            Connected
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CustomIntegrationsCard;
